/* eslint-disable @typescript-eslint/ban-ts-comment */

import { useEffect, useState } from 'react'
import BarcodeReader from '@/checkout-instore-legacy/utils/BarcodeReader'

import { sendWebViewBridgeEvent } from '../../../utils/webview'

declare global {
  interface Window {
    // TODO: this error popped up when moving the checkout-instore project
    // to checkout-instore-legacy, but needs to be fixed at some point
    // @ts-ignore
    handleBarcodeRead: unknown
  }
}

export const useBarcodeReader = () => {
  const [barcode, setBarcode] = useState('')

  const handleBarcodeRead = (event: { data: { barcode: string } }) => {
    const { barcode: barcodeData } = event.data

    if (barcodeData) {
      const rawBarcode = barcodeData.toString()

      setBarcode(rawBarcode)
    }
  }

  const initBarcodeReader = () => {
    BarcodeReader.listen(handleBarcodeRead)
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type '{ barcode... Remove this comment to see the full error message
    window.handleBarcodeRead = (data) => handleBarcodeRead({ data }) // used on custom scripts
  }

  const finishBarcodedReader = () => {
    BarcodeReader.unlisten(handleBarcodeRead)
    window.handleBarcodeRead = null
  }

  useEffect(() => {
    initBarcodeReader()

    return () => {
      finishBarcodedReader()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const openBarcodeReader = () => {
    sendWebViewBridgeEvent({
      type: 'openBarcodeCameraVisible',
    })
  }

  return {
    barcode,
    openBarcodeReader,
  }
}
